<template>
  <default-field :errors="errors" :title="title" :wrap="wrap">
    <template v-slot:field="slotProps">
      <v-select
          class="bg-white"
          :class="[slotProps.hasErrors ? invalidClass : '', className]"
          v-bind="$attrs"
          @input="setValue"
          :multiple="multiple"
          :options="options"
          @search="onSearch"
      />
    </template>
  </default-field>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import DefaultField from "./DefaultField";

export default {
  components: {
    DefaultField
  },

  inheritAttrs: false,

  props: {
    className: {
      type: String,
      default: ""
    },
    invalidClass: {
      type: String,
      default: "is-invalid"
    },
    errors: {
      type: Array,
      default: () => []
    },
    valueName: {
      type: String,
      default: "value"
    },
    options: {
      type: Array
    },
    title: {
      type: String,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    wrap: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    onSearch(search, loading) {
      loading(true)
      this.$emit("search", search)

      loading(false)
    },
    setValue(value) {
      this.$emit("input", value);
    }
  }
};
</script>